import Axios from 'axios'

import { TAppliedFilter, TReportEdition } from 'types/GlobalReport'

import {
  getDefaultConfig,
  getWithRedirect,
  patchWithRedirect,
  postWithRedirect
} from 'utils/axios'

const BASE_URL =
  process.env.NODE_ENV === 'development'
    ? 'http://localhost:3990/'
    : process.env.REACT_APP_HOMEPAL_MDM_API_PROD

const URL = `${BASE_URL}v1/report-editions`

export async function getAll() {
  return getWithRedirect<TReportEdition[]>(URL)
}

export async function create(body: { report_id: string; title?: string }) {
  return postWithRedirect<TReportEdition>(URL, { data: body })
}

export async function update(
  id: string,
  body: {
    title?: string
    status?: string
    lock?: boolean
    from_date?: string | null
    to_date?: string | null
    applied_filters?: TAppliedFilter[]
  }
) {
  return patchWithRedirect<TReportEdition>(`${URL}/${id}`, { data: body })
}

export async function destroy(id: string) {
  return Axios.delete(`${URL}/${id}`, getDefaultConfig())
}
